document.addEventListener('DOMContentLoaded', function () {
  var filterEl = document.querySelector('[data-journal-filter]');
  var grid = document.querySelector('[data-journal-grid]');
  if (!filterEl || !grid) return;

  var pills = Array.prototype.slice.call(filterEl.querySelectorAll('[data-journal-pill]'));
  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-journal-card]'));
  var clearBtn = filterEl.querySelector('[data-journal-clear]');
  var countEl = filterEl.querySelector('[data-journal-count]');
  var seeMoreBtn = filterEl.querySelector('[data-journal-seemore]');
  var extraCount = filterEl.querySelectorAll('.journal-filter__pill--extra').length;
  var active = [];

  function render() {
    cards.forEach(function (card) {
      var cats = (card.getAttribute('data-categories') || '').split(',').filter(Boolean);
      var show = active.length === 0 || cats.some(function (c) { return active.indexOf(c) !== -1; });
      card.hidden = !show;
    });

    pills.forEach(function (pill) {
      var isActive = active.indexOf(pill.getAttribute('data-filter')) !== -1;
      pill.classList.toggle('is-active', isActive);
      pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (clearBtn) clearBtn.hidden = active.length === 0;

    if (countEl) {
      var visible = cards.filter(function (c) { return !c.hidden; }).length;
      countEl.textContent = visible + (visible === 1 ? ' article' : ' articles');
    }
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var filter = pill.getAttribute('data-filter');
      var idx = active.indexOf(filter);
      if (idx === -1) {
        active.push(filter);
      } else {
        active.splice(idx, 1);
      }
      render();
    });
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      active = [];
      render();
    });
  }

  if (seeMoreBtn) {
    seeMoreBtn.textContent = 'See more (+' + extraCount + ')';
    seeMoreBtn.addEventListener('click', function () {
      var expanded = filterEl.classList.toggle('is-expanded');
      seeMoreBtn.textContent = expanded ? 'Hide' : 'See more (+' + extraCount + ')';
    });
  }

  render();
});